var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_leaveBalance_form_viewTitle"),
      pad: "0",
      addBtn: _vm.curTab == "tab-2" && _vm.selectOneStaff ? true : false,
    },
    on: {
      new: function ($event) {
        _vm.showNewTran = true
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass: "transparent d-flex flex-row rounded-lg",
                attrs: { elevation: "0" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "fill-height white rounded-lg pa-0",
                    style: {
                      minHeight:
                        _vm.$vuetify.breakpoint.height - 238 + 42 + "px",
                    },
                    attrs: { elevation: "0", width: "280" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-start px-2 py-2" },
                      [
                        _c("v-autocomplete", {
                          ref: "filterStaff4",
                          staticClass: "py-2 spacial-v-autocomplete",
                          attrs: {
                            items: _vm.allStaff,
                            filled: "",
                            rounded: "",
                            height: "40",
                            dense: "",
                            "allow-overflow": false,
                            "hide-details": "",
                            "append-icon":
                              _vm.filterStaffs.length > 0 && !_vm.isFocus
                                ? "search"
                                : "arrow_drop_down",
                            "single-line": "",
                            placeholder:
                              _vm.$t(
                                "label_essweb_leaveBalance_list_staffNameLabel"
                              ) +
                              "/" +
                              _vm.$t(
                                "label_essweb_leaveBalance_list_staffIdLabel"
                              ),
                            chips: "",
                            "open-on-clear": false,
                            multiple: "",
                            filter: _vm.$staffFilter,
                            "item-text": "staff_code",
                            "item-value": "staff_id",
                          },
                          on: {
                            focus: function ($event) {
                              _vm.isFocus = true
                            },
                            blur: _vm.toFocus,
                            "click:append": function ($event) {
                              _vm.filterStaffs.length > 0 && !_vm.isFocus
                                ? _vm.toSearch()
                                : null
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "no-data",
                                fn: function () {
                                  return [_c("noContent")]
                                },
                                proxy: true,
                              },
                              _vm.allStaff.length > 0
                                ? {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          {
                                            staticClass: "px-4",
                                            attrs: { dense: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.$nextTick(function () {
                                                  if (
                                                    _vm.filterStaffs.length ===
                                                    _vm.allStaff.length
                                                  ) {
                                                    _vm.filterStaffs = []
                                                    _vm.$refs.filterStaff4.blur()
                                                    _vm.$emit("search", null)
                                                  } else {
                                                    _vm.$refs.filterStaff4.blur()
                                                    _vm.filterStaffs = []
                                                    _vm.allStaff.map(function (
                                                      item
                                                    ) {
                                                      _vm.filterStaffs.push(
                                                        item.staff_id
                                                      )
                                                    })
                                                  }
                                                })
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-action",
                                              { staticClass: "mx-0 my-0 mr-1" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons-round",
                                                    class:
                                                      _vm.filterStaffs
                                                        .length !== 0 &&
                                                      _vm.filterStaffs
                                                        .length ===
                                                        _vm.allStaff.length
                                                        ? "primary--text"
                                                        : _vm.filterStaffs
                                                            .length > 0 &&
                                                          _vm.filterStaffs
                                                            .length !==
                                                            _vm.allStaff.length
                                                        ? "primary--text"
                                                        : "text--secondary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.filterStaffs
                                                            .length !== 0 &&
                                                            _vm.filterStaffs
                                                              .length ===
                                                              _vm.allStaff
                                                                .length
                                                            ? "check_box"
                                                            : _vm.filterStaffs
                                                                .length > 0 &&
                                                              _vm.filterStaffs
                                                                .length !==
                                                                _vm.allStaff
                                                                  .length
                                                            ? "indeterminate_check_box"
                                                            : "check_box_outline_blank"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_select_selectAllLabel"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : null,
                              {
                                key: "selection",
                                fn: function (data) {
                                  return [
                                    data.index < 1
                                      ? _c(
                                          "v-chip",
                                          _vm._b(
                                            {
                                              staticClass: "mx-0 mr-1 pr-2",
                                              attrs: { close: "", pill: "" },
                                              on: {
                                                "click:close": function (
                                                  $event
                                                ) {
                                                  return _vm.removeStaff(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            "v-chip",
                                            data.attrs,
                                            false
                                          ),
                                          [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                left: "",
                                                src: data.item.staff_avatar,
                                                staff_name:
                                                  data.item.preferred_name,
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-inline-block text-truncate",
                                                staticStyle: {
                                                  "max-width": "60px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        data.item.preferred_name
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    data.index === 1
                                      ? _c(
                                          "span",
                                          { staticClass: "text--primary py-2" },
                                          [
                                            _vm._v(
                                              " ... " +
                                                _vm._s(
                                                  _vm.filterStaffs.length - 1
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-list",
                                      {
                                        attrs: {
                                          rounded: "",
                                          width: "100%",
                                          nav: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: {
                                              rouned: "",
                                              width: "100%",
                                              nav: "",
                                              "two-line": "",
                                              dense: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "ma-0 mr-1 white--text",
                                                attrs: { size: "36" },
                                              },
                                              [
                                                _c("StaffAvatar", {
                                                  attrs: {
                                                    size: "36",
                                                    src: data.item.staff_avatar,
                                                    staff_name:
                                                      data.item.preferred_name,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-body-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          data.item
                                                            .preferred_name
                                                        )
                                                      ) + " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text--secondary text-caption-xs",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            data.item.staff_code
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        data.item.job_post_name
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.filterStaffs,
                            callback: function ($$v) {
                              _vm.filterStaffs = $$v
                            },
                            expression: "filterStaffs",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("v-divider"),
                    _vm.allStaff.length == 0 && !_vm.staff_Loading
                      ? _c("noContent")
                      : _vm._e(),
                    _vm.staff_Loading
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "text-center d-flex align-center justify-center",
                            style: {
                              minHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                80 +
                                "px",
                            },
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "primary",
                                size: "30",
                                width: "2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.staff_Loading
                      ? _c(
                          "v-list",
                          {
                            staticClass: "scroll_content_y",
                            style: {
                              maxHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                80 +
                                "px",
                            },
                            attrs: { dense: "" },
                          },
                          [
                            _c(
                              "v-list-item-group",
                              {
                                attrs: { color: "primary" },
                                model: {
                                  value: _vm.selectOneStaff,
                                  callback: function ($$v) {
                                    _vm.selectOneStaff = $$v
                                  },
                                  expression: "selectOneStaff",
                                },
                              },
                              _vm._l(_vm.show_Staff, function (staff, index) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: "staff---" + index,
                                    staticClass: "pa-0 px-2 ma-0",
                                    attrs: {
                                      dense: "",
                                      "two-line": "",
                                      value: staff.staff_id,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-avatar",
                                      {
                                        staticClass: "pa-0 ma-0 mr-2",
                                        attrs: { size: "36" },
                                      },
                                      [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            size: "36",
                                            src: staff.staff_avatar,
                                            staff_name: staff.preferred_name,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption-xs",
                                              },
                                              [_vm._v(_vm._s(staff.staff_code))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.job_post_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-card",
                  {
                    staticClass: "ml-3 rounded-lg flex-grow-1",
                    style: {
                      maxWidth: "calc(100% - 292px)",
                    },
                    attrs: { elevation: "0" },
                  },
                  [
                    _c("Taber", {
                      attrs: {
                        special: "",
                        curTab: _vm.curTab,
                        items: _vm.taber,
                      },
                      on: {
                        change: function (tab) {
                          return (_vm.curTab = tab)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "content-1",
                          fn: function () {
                            return [
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.BalanceHeaders,
                                  items: _vm.BalanceDeserts,
                                  height:
                                    _vm.$vuetify.breakpoint.height -
                                    238 +
                                    42 -
                                    95,
                                  totalCount: _vm.totalCount1,
                                },
                                on: {
                                  change: function (page, perpage, callback) {
                                    _vm.getDetail(
                                      _vm.selectOneStaff,
                                      page,
                                      perpage,
                                      callback
                                    )
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.leave_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.unit",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.unit == "D"
                                                    ? _vm.$t(
                                                        "label_essweb_system_dayLabel"
                                                      )
                                                    : item.unit == "H"
                                                    ? _vm.$t(
                                                        "label_essweb_system_hourLabel"
                                                      )
                                                    : _vm.$t(
                                                        "label_essweb_system_minutesLabel"
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.brought_forward",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_brought_forward,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.entitled",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_entitlement,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.earned",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_earned,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.taken_expired",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_taken,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.balance",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_balance,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.pending",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_pending,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.f_balance",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.leave_future_balance,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.action",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return undefined
                                    },
                                  },
                                ]),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content-2",
                          fn: function () {
                            return [
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.TransactionHeaders,
                                  items: _vm.TransactionDeserts,
                                  totalCount: _vm.totalCount2,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.swift_id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.swift_number) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.tr_type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.leave_transaction_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.leave_type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.leave_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.start_date",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.start_utc_datetime,
                                                    "YYYY/MM/DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--secondary table-subtitle",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.start_utc_datetime,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.effect_date",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.effective_utc_datetime,
                                                    "YYYY/MM/DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.expiry_date",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    item.expired_utc_datetime,
                                                    "YYYY/MM/DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.unit",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.unit == "D"
                                                    ? _vm.$t(
                                                        "label_essweb_system_dayLabel"
                                                      )
                                                    : item.unit == "H"
                                                    ? _vm.$t(
                                                        "label_essweb_system_hourLabel"
                                                      )
                                                    : _vm.$t(
                                                        "label_essweb_system_minutesLabel"
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.total",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f(
                                                    "CalculationByDHFilter"
                                                  )(
                                                    item.total_minutes,
                                                    item,
                                                    _vm.CalculationByDH
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.status",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("StatusChip", {
                                          attrs: {
                                            slideColor:
                                              item.status_value == "1"
                                                ? "orange"
                                                : item.status_value == "2" ||
                                                  item.status_value == "3" ||
                                                  item.status_value == "4"
                                                ? "grey"
                                                : item.status_value == "0" ||
                                                  item.status_value == "5" ||
                                                  item.status_value == "6"
                                                ? "green"
                                                : "currentColor",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "status",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            item.status_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.action",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", icon: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.detailUuid = item.uuid
                                                _vm.showViewTran = true
                                              },
                                            },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                size: "24",
                                                fill: "currentColor",
                                                iconClass: "viewDetail",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("normalDialog", {
              attrs: {
                dialog: _vm.showDelete,
                deleteModel: "",
                title: "Leave Balance",
              },
              on: {
                close: function ($event) {
                  _vm.showDelete = false
                },
                confirm: _vm.toDelete,
              },
            }),
            _c("newTransactions", {
              attrs: {
                show: _vm.showNewTran,
                staff_uuid: _vm.selectOneStaff,
                curUuid: _vm.selectOneStaff,
              },
              on: {
                close: function ($event) {
                  _vm.showNewTran = false
                },
                onNew: _vm.onNewTransaction,
              },
            }),
            _c("viewTransactions", {
              attrs: {
                show: _vm.showViewTran,
                staff_uuid: _vm.selectOneStaff,
                curUuid: _vm.selectOneStaff,
                detailUuid: _vm.detailUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showViewTran = false
                  _vm.detailUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }